import React from 'react';
import { AuthMainContainerPropsType } from './types';
import AuthLayout from '../../components/Layout';

const AuthMainContainer: React.FC<AuthMainContainerPropsType> = () => {
	return <AuthLayout />;
};

export default AuthMainContainer;
